import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '@/lib/api';

/**
 * Jejak halaman terakhir (tingkat modul) supaya navigasi SPA dapat mencatat
 * perujuk internal. `document.referrer` hanya dipakai untuk muat pertama.
 */
let previousPath: string | null = null;

/**
 * Mencatat kunjungan halaman ke `POST /analytics/visits` setiap kali rute
 * berubah. Identitas pengunjung (bila login) ditentukan server dari sesi.
 * Kegagalan diabaikan agar tidak mengganggu pengalaman pengguna.
 */
export function VisitLogger() {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    const referrer = previousPath ?? (document.referrer || null);
    previousPath = path;

    // Tunda sesaat: membatalkan kirim bila pengguna langsung berpindah lagi
    // dan mencegah kiriman ganda saat React StrictMode memuat ulang efek.
    const timer = window.setTimeout(() => {
      void api
        .post('/analytics/visits', { path, referrer: referrer ?? undefined })
        .catch(() => {
          /* abaikan: log kunjungan bersifat best-effort */
        });
    }, 400);

    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
}
